import type { BreadcrumbItem } from "@nuxt/ui";
import { defineStore } from "pinia";

export const useBreadcrumbStore = defineStore("breadcrumb", () => {
  const breadcrumbs = ref<BreadcrumbItem[]>([]);

  return {
    breadcrumbs,
  };
});
